import axios from 'axios';
import * as types from '../mutation-types';
import config from '../../constants';

export const state = () => ({
    wishlist: {},
    user: {},
});

export const getters = {
    wishlist: state => state.wishlist,
    check: state => state.user !== null,
    user: state => state.user,
    isProductManager(state, getters) {
        if (state.user && state.user.roles) {
            return state.user.roles.find(role => role.name == config.role_product_manager) != undefined;
        } else {
            return false;
        }
    },
    isAdmin(state, getters) {
        if (state.user && state.user.roles) {
            return state.user.roles.find(role => role.name == config.role_admin) != undefined;
        } else {
            return false;
        }
    },
};

export const mutations = {
    [types.FETCH_WISHLIST](state, { wishlist }) {
        // console.log(wishlist);
        state.wishlist = wishlist;
    },
    [types.SET_WISHLIST](state, wishlist) {
        state.wishlist = wishlist;
    },
    [types.SET_USER](state, user) {
        state.user = user;
    },
};

export const actions = {
    async fetchWishlist({ commit }) {
        try {
            const { data } = await axios.get('/user/wishlist');
            commit(types.FETCH_WISHLIST, {
                wishlist: data,
            });
        } catch (e) {
            commit(types.FETCH_WISHLIST_FAILURE);
        }
    },
};
